module.exports = __webpack_public_path__ + "img/shiny-card.7847b2dd.svg";